import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'

import {
  IncidentQueuePayloadConfig,
  IncidentsQueuePayloadConfig,
} from '../../configuration'

const sharedBreakAfterIncidentConfig: IncidentQueuePayloadConfig = {
  addIncident: (payload, queue) => {
    queue.addIncident({
      ...payload,
      incident_id: VolleyballIncidentId.BreakAfter,
    })

    queue.addIncident(payload)
  },
}
export const incidentsQueuePayloadConfig: IncidentsQueuePayloadConfig<VolleyballIncidentId> =
  {
    [VolleyballIncidentId.BreakAfterFirstSet]: sharedBreakAfterIncidentConfig,
    [VolleyballIncidentId.BreakAfterSecondSet]: sharedBreakAfterIncidentConfig,
    [VolleyballIncidentId.BreakAfterThirdSet]: sharedBreakAfterIncidentConfig,
    [VolleyballIncidentId.BreakAfterFourthSet]: sharedBreakAfterIncidentConfig,
    [VolleyballIncidentId.BreakAfterFifthSet]: sharedBreakAfterIncidentConfig,
    [VolleyballIncidentId.Dig]: {
      addIncident: (payload, queue) => {
        queue.addIncident({
          ...payload,
          incident_id: VolleyballIncidentId.Dig,
        })
        queue.addIncident({
          ...payload,
          attribute_id: undefined,
          incident_id: VolleyballIncidentId.Set,
        })
      },
    },
    [VolleyballIncidentId.Reception]: {
      addIncident: (payload, queue) => {
        queue.addIncident({
          ...payload,
          incident_id: VolleyballIncidentId.Reception,
        })
        queue.addIncident({
          ...payload,
          attribute_id: undefined,
          incident_id: VolleyballIncidentId.Set,
        })
      },
    },
  }
